import PropTypes from 'prop-types'
import { ProfilePicture } from '../../../../components/generic'
import { css, StyleSheet } from 'aphrodite/no-important'
import { colors } from '@lmc/common/constants'
import { Button, Edit } from '@lmc/ui-kit'
import { isBrowser, isTablet } from 'react-device-detect'

export default function ZoneResidentRow({ onEdit, resident, isLast }) {
  return (
    <li
      className={`${css(classes.container)} zone-resident`}
      style={!isLast ? { borderBottom: `1px solid ${colors.grey}` } : {}}
    >
      <div className={css(classes.leftContainer)}>
        <ProfilePicture
          style={{ marginRight: 10 }}
          url={resident.picture}
          type="handover__small"
        />
        <div className={css(classes.nameContainer)}>
          {resident.name.first} {resident.name.last}
        </div>
      </div>
      <div className={css(classes.rightContainer)}>
        <Button
          className={
            isBrowser || isTablet
              ? `${css(classes.button)} hover-buttons`
              : `${css(classes.button)}`
          }
          onClick={() => onEdit(resident)}
          variant="default"
        >
          <Edit />
          Edit
        </Button>
      </div>
    </li>
  )
}

const classes = StyleSheet.create({
  button: {
    fontSize: 12,
    transition: 'all .2s ease',
    textShadow: 'none',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 16,
    transition: 'all .2s ease',
    background: colors.white,
    ':hover': {
      background: colors.lightgrey,
    },
  },
  leftContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    minWidth: 0,
  },
  nameContainer: {
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: 16,
    fontWeight: 700,
  },
  rightContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 12,
    minWidth: 0,
  },
  picture: {
    marginRight: 10,
  },
})

ZoneResidentRow.propTypes = {
  onEdit: PropTypes.func.isRequired,
  resident: PropTypes.object.isRequired,
}
